import { apiQuery } from '../';

export const mcoStepApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getStepById: builder.query({
        query: ({ outreachId, stepId }) => {
          return {
            method: 'get',
            url: `/outreaches/${outreachId}/steps/${stepId}`,
          };
        },
        transformResponse: (response) => response.data,
      }),

      addOutreachStep: builder.mutation({
        transformResponse: (response) => response.data,
        query: (payload) => {
          const { outreachId, step } = payload;
          return {
            url: `/outreaches/${outreachId}/steps`,
            method: 'post',
            data: { step },
          };
        },
      }),

      updateOutreachStep: builder.mutation({
        transformResponse: (response) => response.data,
        query: (payload) => {
          const { outreachId, stepId, step } = payload;
          return {
            url: `/outreaches/${outreachId}/steps/${stepId}`,
            method: 'patch',
            data: { step },
          };
        },
      }),

      reorderStep: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ outreachId, steps }) => {
          return {
            url: `/outreaches/${outreachId}/steps/reorder`,
            method: 'put',
            data: { steps },
          };
        },
      }),

      uploadInlineImage: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ file }) => {
          const formData = new FormData();
          formData.append('file', file);

          return {
            url: `/user_image_uploads`,
            method: 'post',
            data: formData,
          };
        },
      }),

      saveSteps: builder.mutation({
        transformResponse: (response) => response,
        query: ({ flowId, contactId, payload }) => {
          return {
            url: `/outreaches/${flowId}/candidates/${contactId}/personalised_steps`,
            method: 'put',
            data: { steps_info: [payload] },
          };
        },
        invalidatesTags: ['GetOutreachCandidates'],
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetStepByIdQuery,
  useAddOutreachStepMutation,
  useUpdateOutreachStepMutation,
  useReorderStepMutation,
  useUploadInlineImageMutation,
  useSaveStepsMutation,
} = mcoStepApi;
